import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { Center } from "@chakra-ui/react";
import Login from "./Routes/Login";
import { useAuth } from "./Contexts/AuthContext";
import Verify from "./Routes/Verify";

const UnauthenticatedApp = () => {
  const { user } = useAuth();
  return (
    <Center w="full" h="100vh" bg="white">
      <Routes>
        {user ? (
          <>
            <Route path="/verify" element={<Verify />} />
            <Route
              path="*"
              element={<Navigate to="/verify" replace={true} />}
            />
          </>
        ) : (
          <>
            <Route path="/login" element={<Login />} />
            <Route path="*" element={<Navigate to="/login" replace={true} />} />
          </>
        )}
      </Routes>
    </Center>
  );
};

export default UnauthenticatedApp;
